import { render, staticRenderFns } from "./PublipostageForm.vue?vue&type=template&id=fbe24a94&scoped=true&"
import script from "./PublipostageForm.vue?vue&type=script&lang=js&"
export * from "./PublipostageForm.vue?vue&type=script&lang=js&"
import style0 from "./PublipostageForm.vue?vue&type=style&index=0&id=fbe24a94&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbe24a94",
  null
  
)

export default component.exports